import type { PositionNameResolver } from '@sportninja/common/features/playerFinder/candidateDisplay'
import { usePositionOptions } from 'src/features/team/player/hooks/useRosterPlayer'

// Builds a player_type_id → position name resolver for a sport, reusing the
// same Redux-backed player-type list the roster/attendance screens use.
export const usePositionNameResolver = (
  sportId?: string
): PositionNameResolver => {
  'use memo'
  const options = usePositionOptions(sportId ?? null)
  const byId = new Map(options.map((o) => [o.value, o.label]))
  return (playerTypeId?: number | null) =>
    playerTypeId == null ? undefined : byId.get(String(playerTypeId))
}
